<div class="content-hack">
	<div class="col-md-12">
		<div class="container-fluid tp-box">
			<div class="row tp-box__side tp-box__front">
				<div class="col-12" *ngIf="!loading && !status?.configured">
					<div class="card card-stats">
						<div class="card-header card-header-warning card-header-icon">
							<div class="card-icon">
								<i class="material-icons">settings</i>
							</div>
							<p class="card-category">3PL integration is not configured</p>
							<h3 class="card-title">—</h3>
							<small>
								<p class="card-category text-info text-justify mt-3 text-right">Open 3PL settings to choose your provider and warehouse.</p>
							</small>
						</div>
						<div class="card-footer">
							<div class="stats">
								<a routerLink="/tpl3pl/config" class="btn btn-primary btn-sm">3PL settings</a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 text-center py-5" *ngIf="loading">
					<svg class="spinner" width="48px" height="48px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
					<p class="mt-3 mb-0 text-muted">Loading dashboard data…</p>
				</div>

				<ng-container *ngIf="!loading && status?.configured">
					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-primary card-header-icon">
								<div class="card-icon">
									<i class="material-icons">power</i>
								</div>
								<p class="card-category">Integration</p>
								<h3 class="card-title">{{ status?.integration_type || '—' }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Warehouse: {{ status?.warehouse_code || '—' }}<br>
										<span [class.text-success]="status?.enabled" [class.text-danger]="!status?.enabled">{{ status?.enabled ? 'Active' : 'Disabled' }}</span><span *ngIf="status?.test_mode"> · Test</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a href="javascript:void(0)" (click)="loadStatus(); $event.preventDefault()" class="pointer"><i class="material-icons">refresh</i> Refresh</a>
								</div>
								<div class="stats">
									<a routerLink="/tpl3pl/config"><i class="material-icons">settings</i> 3PL settings</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-success card-header-icon">
								<div class="card-icon">
									<i class="material-icons">inventory_2</i>
								</div>
								<p class="card-category">Catalog SKUs</p>
								<h3 class="card-title">{{ status?.catalog_items ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">Active in-scope SKUs </p>
								</small>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-warning card-header-icon">
								<div class="card-icon">
									<i class="material-icons">local_shipping</i>
								</div>
								<p class="card-category">Order Export Queue</p>
								<h3 class="card-title">{{ (status?.queue_exported ?? 0) + (status?.queue_pending ?? 0) }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Exported: <span class="text-success">{{ status?.queue_exported ?? 0 }}</span> ·
										Pending: <span class="text-warning">{{ status?.queue_pending ?? 0 }}</span> ·
										Failed: <span class="text-danger">{{ status?.queue_failed ?? 0 }}</span>
										<span *ngIf="(status?.queue_dead_letter ?? 0) > 0"> · Dead: {{ status?.queue_dead_letter }}</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/export-queue"><i class="material-icons">visibility</i> View Queue</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-info card-header-icon">
								<div class="card-icon">
									<i class="material-icons">store</i>
								</div>
								<p class="card-category">Inventory Synced</p>
								<h3 class="card-title">{{ status?.inventory_synced ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Pending: {{ status?.inventory_pending ?? 0 }} · Errors: <span [class.text-danger]="(status?.inventory_errors ?? 0) > 0">{{ status?.inventory_errors ?? 0 }}</span><br>
										Last sync: {{ (status?.last_sync | date:'short') || 'Never' }}
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/inventory"><i class="material-icons">visibility</i> View</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-info card-header-icon">
								<div class="card-icon">
									<i class="material-icons">local_shipping</i>
								</div>
								<p class="card-category">Shipments</p>
								<h3 class="card-title">{{ status?.shipments_total ?? 0 }}</h3>
								<small *ngIf="(status?.shipments_unprocessed ?? 0) > 0">
									<p class="card-category text-info text-justify mt-3 text-right">
										Unprocessed: <span class="text-warning">{{ status?.shipments_unprocessed }}</span>
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/shipments"><i class="material-icons">visibility</i> View</a>
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-rose card-header-icon">
								<div class="card-icon">
									<i class="material-icons">show_chart</i>
								</div>
								<p class="card-category">Exports (24h)</p>
								<h3 class="card-title">{{ status?.exports_24h ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right">
										Failure rate: <span [class.text-danger]="(status?.failure_rate_24h ?? 0) > 10" [class.text-success]="(status?.failure_rate_24h ?? 0) === 0">{{ status?.failure_rate_24h ?? 0 }}%</span><br>
										Last export: {{ (status?.last_export | date:'short') || 'Never' }}
									</p>
								</small>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-4 col-sm-6">
						<div class="card card-stats">
							<div class="card-header card-header-danger card-header-icon">
								<div class="card-icon">
									<i class="material-icons">warning</i>
								</div>
								<p class="card-category">Recent errors</p>
								<h3 class="card-title">{{ status?.recent_errors?.length ?? 0 }}</h3>
								<small>
									<p class="card-category text-info text-justify mt-3 text-right tpl3pl-error-preview" *ngIf="status?.recent_errors?.length">
										{{ previewFirstError(status.recent_errors[0]) }}
									</p>
									<p class="card-category text-success text-justify mt-3 text-right" *ngIf="!status?.recent_errors?.length">
										No recent errors
									</p>
								</small>
							</div>
							<div class="card-footer">
								<div class="stats">
									<a routerLink="/tpl3pl/logs"><i class="material-icons">visibility</i> View logs</a>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>